import BaseService from '@/api/base.service';
import configApi from '@/api/config';

/**
 * @class ImportService
 */
class ImportService extends BaseService {
  constructor() {
    super({ baseUrl: configApi.baseRoutesUrls.imports });
  }
}

const singletonInstance = new ImportService();

/**
 * @exports api/modules/import.service.js
 * */
export default singletonInstance;
